export const remCalc = (px: number) => `${0.0625 * px}rem`
